import React, { Component } from 'react'
import { connect } from 'react-redux'
import PlayerFeed from './PlayerFeed'
import { getParticipant, removePlayerFromLoaded } from '../../actions'

class PlayerPage extends Component {
  componentDidMount () {
    const id = this.props.match.params.id
    const player = this.props.participants.find(p => p.id === id)
    !player && this.props.dispatch(getParticipant(id))
  }

  componentWillUnmount () {
    const id = this.props.match.params.id
    const player = this.props.participants.find(p => p.id === id)

    if (player && !player.location.includes(this.props.location)) {
      this.props.dispatch(removePlayerFromLoaded(id))
    }
  }

  componentWillReceiveProps (nextProps) {
    const id = this.props.match.params.id
    const player = this.props.participants.find(p => p.id === id)
    const newPlayer = nextProps.participants.find(p => p.id === id)
    if (player && !newPlayer) {
      this.props.dispatch(getParticipant(id))
    }
  }

  render () {
    const id = this.props.match.params.id
    const player = this.props.participants.find(t => t.id === id)
    return (
      <PlayerFeed {...player} />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    participants: state.participants,
    location: state.auth.user.location
  }
}

export default connect(mapStateToProps)(PlayerPage)



// WEBPACK FOOTER //
// ./src/screens/player/PlayerPage.js